module.exports = __webpack_public_path__ + "img/name_j.e079fe95.png";